// Components
import accordion from './components/accordion';
import mainMenu from './mainMenu';
import siteWide from './siteWide';
import teamGlobe from './teamGlobe';
import dealHover from './dealHover';
import teamSlider from './teamSlider';
// import particles from './particles';
import gallery from './components/gallery';
import textCircles from './components/text';
import whereNext from './components/where-next';

import bannerDeal from './components/banner-deal';
import bannerPost from './components/banner-post';
import bannerHome from './components/banner-home';
import bannerServices from './components/banner-services';

import quotes from './components/quotes';
import teaserArticle from './components/teaser-article';
import servicesTabs from './components/services-tabs';
import popups from './popups';
import testimonials from './components/testimonials';
import sectorAccordions from './components/sector-accordions';

import { $qs, $qsa } from './utils/QuerySelector';


import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
import ScrollSmoother from "gsap/ScrollSmoother";

gsap.registerPlugin(ScrollTrigger, ScrollSmoother);


// Packages
// import 'slick-carousel';
// import 'magnific-popup';



function init() {
	// accordion();
	mainMenu();
	siteWide();
	dealHover();
	// particles();
	gallery();
	textCircles();
	popups();
	testimonials();
	bannerDeal();
	bannerPost();
	teaserArticle();
	quotes();
	teamGlobe();
	bannerHome();
	teamSlider();
	servicesTabs();
	sectorAccordions();
	bannerServices();
	whereNext();

}


init();





jQuery(document).ready(function ($) {
    consoleMessage: {
        console.log('%cCreated by %cTWK%cwww.thewebkitchen.co.uk', 'background: #13212E; color: #FFFFFF; padding: 5px 0px 5px 10px; margin: 25px 0px;', 'background: #13212E; color: #05E5C8; padding: 5px 10px 5px 0px; font-weight: bold;', 'background: #FFFFFF; padding: 5px 10px;');
	}

	smoothScroll: {

   

	}



	// anchorlinks: {
	// 	$(document).on('click', '.scroll-to', function (event) {
	// 		event.preventDefault();

	// 		$('html, body').animate({
	// 			scrollTop: $($.attr(this, 'href')).offset().top
	// 		}, 500);
	// 	});
	// }

	externallinks: {
		$('a[href^="mailto:"]').each(function () {
			$(this).addClass('email-link');
		});	 
		
		$('a:not(.email-link):not([class^="magnific-"]):not([data-js="video-popup"])').each(function () {
			var a = new RegExp('/' + window.location.host + '/');
			
			if (!a.test(this.href)) {
				$(this).click(function (event) {
				event.preventDefault();
				window.open(this.href, '_blank');
				});
			}
		});
		pdfs: {
			// Open PDFs in new window
			$(function () {
				$('a[href$=".pdf"]').prop('target', '_blank');
			});
		}
	}

	

	accordion: {
		if ($('.block--accordion').length) {

			$( '.accordion__content--wrapper' ).css('display', 'none'); // All items closed.
	
			$('.block--accordion').find('.js-accordion-trigger').on('click', function() {

				// Close only the items in this accordion.
				$(this).parent().siblings().find('.js-accordion-trigger').next().slideUp('fast'); // reset
				$(this).parent().siblings().find('.js-accordion-trigger').removeClass('open');    // reset

				// Close items in all accordions on the page.
				//$('.js-accordion-trigger').not(this).next().slideUp('fast'); // reset
				//$('.js-accordion-trigger').not(this).removeClass('open');    // reset
				
				if ($(this).hasClass('open')){
					$(this).next().slideUp('fast');
					$(this).removeClass('open');
				} else {
					$(this).next().slideDown('fast');
					$(this).addClass('open');
				}
				
			});
		}
	}

	/* tabs: {
		const tabs = document.querySelectorAll('[role="tab"]');
		const tabList = document.querySelector('[role="tablist"]');

		if ( tabs ) {

			// Add a click event handler to each tab
			tabs.forEach(tab => {
				tab.addEventListener("click", changeTabs);
			});

			// Enable arrow navigation between tabs in the tab list
			let tabFocus = 0;

			if ( tabList ) {
				tabList.addEventListener("keydown", e => {
					// Move right
					if (e.keyCode === 39 || e.keyCode === 37) {
					tabs[tabFocus].setAttribute("tabindex", -1);
					if (e.keyCode === 39) {
						tabFocus++;
						// If we're at the end, go to the start
						if (tabFocus >= tabs.length) {
						tabFocus = 0;
						}
						// Move left
					} else if (e.keyCode === 37) {
						tabFocus--;
						// If we're at the start, move to the end
						if (tabFocus < 0) {
						tabFocus = tabs.length - 1;
						}
					}
	
					tabs[tabFocus].setAttribute("tabindex", 0);
					tabs[tabFocus].focus();
					}
				});
			}

			function changeTabs(e) {
				console.info('tabs clicked');
				const target = e.target;
				const parent = target.parentNode;
				const grandparent = parent.closest('.tabs');


					console.info(grandparent);
				// Remove all current selected tabs
				parent
					.querySelectorAll('[aria-selected="true"]')
					.forEach(t => t.setAttribute("aria-selected", false));

				// Set this tab as selected
				target.setAttribute("aria-selected", true);

				// Hide all tab panels
				grandparent
					.querySelectorAll('[role="tabpanel"]')
					.forEach(p => p.setAttribute("hidden", true));

				// Show the selected panel
				grandparent.parentNode
					.querySelector(`#${target.getAttribute("aria-controls")}`)
					.removeAttribute("hidden");
			}

		}
	} */

});


